function toEmbed(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { type: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
  const vim = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vim) return { type: "iframe", src: `https://player.vimeo.com/video/${vim[1]}` };
  if (/\.(mp4|webm|mov)(\?.*)?$/i.test(url)) return { type: "video", src: url };
  return { type: "iframe", src: url };
}

export default function VideoTour({ url, title }) {
  const embed = toEmbed(url);
  if (!embed) return null;
  return (
    <div data-testid="video-tour" className="border border-[#0A1128]/12 bg-white p-8 mt-14">
      <h2 className="font-serif text-2xl text-[#0A1128] mb-5">Video Tour</h2>
      <div className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: "16 / 9" }}>
        {embed.type === "iframe" ? (
          <iframe
            title={`Video tour of ${title}`}
            src={embed.src}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ border: 0 }}
          />
        ) : (
          <video src={embed.src} controls className="absolute inset-0 w-full h-full object-cover" />
        )}
      </div>
    </div>
  );
}
